export function SaveCreditorGroup(this: any) {
  return {
    groupName: this.groupName,
    displayName: this.description,
    description: this.description
  };
}
